import AllTasks from './AllTasks';
import './styles.scss';

const exports = { AllTasks };
export default exports;
